import customHeaders, { getSpace } from '../../common/headers';
import { LineChart } from '../../charts/LineChart/LineChart';
import { SliderRange } from '../../components/Slider/Slider';
import { FiltersBreadCrumbs } from '../../components/FiltersBreadCrumbs/FiltersBreadCrumbs';
import {
  AndreySkuHttps,
  AndreySkuHttp,
} from '../../fetchUrls';
import { useChartData } from '../../common/hooks';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import {
  DropDownSelector,
  DropContainer,
  Tabs,
  RangeBox,
  TableBox,
  CheckboxToggleBlue,
  Checkbox,
   Tooltip
} from '@lk-gtcom/ecomlab-components';
import useGeneralStore from '../../store/general';
import './AnalysisCategory.scss';
import { TitlePage } from '../../components/TitlePage/TitlePage';
import { periodWeek } from '../../common/constant';
import { msToLocalDate } from '../../common/constant';

const btn_tab = [
  {
    label: 'Топ 30',
    value: 'top',
  },
  {
    label: 'Товары',
    value: 'goods',
  },
  {
    label: 'Бренды',
    value: 'brands',
  },
  {
    label: 'Продавцы',
    value: 'sellers',
  },
  {
    label: 'По дням',
    value: 'days',
  },
  {
    label: 'По типам продаж',
    value: 'working_scheme',
  },
  {
    label: 'Ценовые сегменты',
    value: 'price_segment',
  },
];

const options_period = [
  {
    label: 'дням',
    value: 'day',
  },
  {
    label: 'неделям',
    value: 'week',
  },

  {
    label: 'месяцам',
    value: 'month',
  },
];

const sales_type = [
  { value: 5, label: 'Все' },
  { value: 1, label: 'FBO' },
  { value: 2, label: 'FBS' },
  { value: 3, label: 'Из-за рубежа' },
  { value: 4, label: 'RFBS' },
];

const formateDate = (date) => {
  const timeZone = (new Date().getTimezoneOffset() / 60) * -3600000;
  const formate_date = new Date(
    new Date(date)?.getTime() + timeZone
  )?.toUTCString();
  return new Date(formate_date);
};

const AnalysisCategory = ({ setShowTooltipAnalysisCategory }) => {
  const selectedSpace = useGeneralStore(state => state.selectedSpace)
  const headers = { ...customHeaders, ...getSpace(selectedSpace) }
  const [query, setQuery] = useState(null);
  const [pageValue, setPageValue] = useState('category');

  const [fetchedData, setFetchedData] = useState([]);
  const [tableHeaders, setTableHeaders] = useState([]);
  const [sort, setSort] = useState({});
  const [columnSize, setColumnSize] = useState([]);

  const [checkedItems, setCheckedItems] = useState([]);

  const [priceRange, setPriceRange] = useState([0, 0]);
  const [segments, setSegments] = useState(1);

  const [date, setDate] = useState(periodWeek());
  const [searchParams, setSearchParams] = useSearchParams();
  const [tableUrl, setTableUrl] = useState('');
  const [tableBody, setTableBody] = useState(null);
  const [mp, setMp] = useState('ozon');
  const activeTab = useParams()['*'];

  const [selectedItems, setSelectedItems] = useState([]);

  const [tableMetrics, setTableMetrics] = useState([]);
  // const [tableMetric, setTableMetric] = useState('IDC');
  const [tableMetric, setTableMetric] = useState('');
  const [isReverse, setIsReverse] = useState(false);

  const [dateOptions, setDateOptions] = useState([]);
  const [selectedDateOptions, setSelectedDateOptions] = useState({});
  const [selectedSalesType, setSelectedSalesType] = useState(sales_type?.at(0));
  const [checkFbs, setCheckFbs] = useState(false);

  const [metrics, setMetrics] = useState([]);
  const [selectedMetrics, setSelectedMetrics] = useState([]);

  const [metricsList, setMetricsList] = useState([]);
  const [selectedMetric, setSelectedMetric] = useState('IDC');

  const [setChartData, chartData, setChartFuncs] = useChartData();
  const { setChartLoading, resetChart } = setChartFuncs;

  const [minMaxRange, setMinMaxRange] = useState([0, 0]);

  const [showDropBox, setShowDropBox] = useState(false);

  const [choisePrice, setChoisePrice] = useState([]);

  const [loading, setLoading] = useState(false);

  const [selectedBreadcrumbsValue, setSelectedBreadcrumbsValue] = useState([]);
  const [selectedPeriod, setSelectedPeriod] = useState(options_period[0]);

  const [showMenu, setShowMenu] = useState(false);

  const paginatorRef = useRef();

  const resetTable = () => {
    paginatorRef.current.reset();
    paginatorRef.current.setTotal(0);
    setSort({});
    setTableHeaders([]);
    setFetchedData([]);
  };

  const fetchChartData = (
    abortController = new AbortController(),
    clearOnSuccess = false
  ) => {
    setChartLoading(true);

    let url;
    if (!window.location.hostname.match('localhost')) {
      url = `${AndreySkuHttps}/api/v1/ecomru/competitors/${mp === 'ozon' ? 'ozon_analysis' : 'platform_analysis'
        }/category/${pageValue}/graph/`;
    } else {
      url = `${AndreySkuHttp}/api/v1/ecomru/competitors/${mp === 'ozon' ? 'ozon_analysis' : 'platform_analysis'
        }/category/${pageValue}/graph/`;
    }

    let category_values = selectedBreadcrumbsValue?.map((el) => el?.value?.id);
    let res;
    if (category_values?.length > 0) {
      res = category_values.at(-1)
        ? category_values.at(-1)
        : category_values.at(-2);
    }

    let searchId;
    let [date_from, date_to] = date;
    date_from = msToLocalDate(date_from);
    date_to = msToLocalDate(date_to);

    const id_arr = selectedItems?.map((el) => {
      if (el) {
        if (pageValue === 'top' && el?.['Категория'] && mp == 'ozon') {
          if (Array.isArray(el?.['Категория'])) {
            const [img, name] = el?.['Категория'];
            return el?.['Категория'][0];
          }
        }
        if (pageValue === 'goods') {
          return el?.nm_id;
        }
        if (pageValue === 'working_scheme') {
          return el?.working_scheme;
        }
        if (pageValue === 'top' && mp == 'wb') {
          return el?.category_id;
        }
        if (pageValue === 'brands') {
          if (mp == 'ozon') return el?.brand_name;
          if (mp == 'wb') return el?.brand_id;
        }
        if (pageValue === 'sellers') {
          if (mp == 'ozon') return el?.seller_name;
          if (mp == 'wb') return el?.seller_id;
        }
        if (pageValue === 'category') {
          if (mp == 'ozon') return el?.category_name;
          if (mp == 'wb') return el?.category_id;
        }
      }
    });

    searchId =
      pageValue == 'top'
        ? mp == 'ozon'
          ? { category_name: id_arr }
          : { category_id: id_arr }
        : '';

    // let seller_data = pageValue == 'top' ?
    //     ''
    //     :
    //     mp == 'ozon' ? { seller_name_filter: search } : { seller_id_filter: search }

    if (pageValue === 'goods') {
      searchId = { nm_id: id_arr };
    }
    if (pageValue === 'working_scheme') {
      searchId = { working_scheme: id_arr };
    }
    if (pageValue === 'brands') {
      if (mp == 'ozon') searchId = { brand_name: id_arr };
      if (mp == 'wb') searchId = { brand_id: id_arr };
    }
    if (pageValue === 'queries') {
      searchId = { query: id_arr };
    }
    if (pageValue === 'category') {
      if (mp == 'ozon') searchId = { category_name: id_arr };
      if (mp == 'wb') searchId = { category_id: id_arr };
    }
    if (pageValue === 'sellers') {
      if (mp == 'ozon') searchId = { seller_name: id_arr };
      if (mp == 'wb') searchId = { seller_id: id_arr };
    }

    const priceData =
      pageValue == 'price_segment'
        ? {
          min_price: choisePrice[0],
          max_price: choisePrice[1],
        }
        : {};

    const body_ozon = JSON.stringify({
      working_scheme_filter: selectedSalesType?.value,
      category_name_filter: res,
      date_period: selectedDateOptions?.value,
      page: 1,
      limit: 300,
      metrics: [],
      ...priceData,
      metric_name: tableMetric,
      ...searchId,
    });

    const body_wb = JSON.stringify({
      date_from,
      date_to,
      page: 1,
      limit: 300,
      category_id_filter: res,
      fbofbs_filter: checkFbs,
      metrics: [],
      ...priceData,
      metric_name: tableMetric,
      ...searchId,
    });

    const current_body = mp == 'wb' ? body_wb : body_ozon;

    fetch(url, {
      body: current_body,
      method: 'POST',
      headers,
      signal: abortController.signal,
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw Error(JSON.stringify(res.json()));
        }
      })
      .then((json) => {
        setChartData(json);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        if (abortController.signal.aborted) return;
        setChartLoading(false);
      });
  };

  const fetchMetricsList = (
    abortController = new AbortController(),
    clearOnSuccess = false
  ) => {
    if (pageValue != 'working_scheme') {
      let url;
      if (!window.location.hostname.match('localhost')) {
        url = `${AndreySkuHttps}/api/v1/ecomru/competitors/${mp === 'ozon' ? 'ozon_analysis' : 'platform_analysis'
          }/category/${pageValue}/metric_list/`;
      } else {
        url = `${AndreySkuHttp}/api/v1/ecomru/competitors/${mp === 'ozon' ? 'ozon_analysis' : 'platform_analysis'
          }/category/${pageValue}/metric_list/`;
      }

      fetch(url, { method: 'GET', headers, signal: abortController.signal })
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw Error(JSON.stringify(res.json()));
          }
        })
        .then((json) => {
          setTableMetrics(json);
          // setTableMetric(json[0]?.value);
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          if (abortController.signal.aborted) return;
          setChartLoading(false);
        });
    }
  };

  const fetchAllAccountData = (
    params,
    abortController = new AbortController()
  ) => {
    if (pageValue != 'top' && selectedBreadcrumbsValue?.length < 1) {
      resetTable();
      return;
    }

    if (mp == 'ozon' && !selectedDateOptions?.value) return;

    setLoading(true);

    let sort;
    let filters;

    if (params) {
      [sort, filters] = params;
    }
    setLoading(true);

    let url;
    if (!window.location.hostname.match('localhost')) {
      url = `${AndreySkuHttps}/api/v1/ecomru/competitors/${mp === 'wb' ? 'platform_analysis' : 'ozon_analysis'
        }/category/${pageValue}/table/`;
    } else {
      url = `${AndreySkuHttp}/api/v1/ecomru/competitors/${mp === 'wb' ? 'platform_analysis' : 'ozon_analysis'
        }/category/${pageValue}/table/`;
    }

    let date_from = formateDate(date[0]).toISOString().split('T')?.[0];
    let date_to = formateDate(date[1]).toISOString().split('T')?.[0];

    let category_values = selectedBreadcrumbsValue?.map((el) => el?.value?.id);
    let res;
    if (category_values?.length > 0) {
      res = category_values.at(-1)
        ? category_values.at(-1)
        : category_values.at(-2);
    }

    const params_q = new URL(document.location).searchParams;
    let query = params_q.get('mp');
    const fbofbs_filter = query == 'wb' ? { fbofbs_filter: checkFbs } : false;
    let working_scheme_filter =
      query == 'ozon'
        ? { working_scheme_filter: selectedSalesType?.value }
        : false;

    const price =
      pageValue == 'price_segment'
        ? {
          max_price: priceRange[1],
          min_price: priceRange[0],
          number_of_segments: +segments,
        }
        : {};

    const body_wb = JSON.stringify({
      ...fbofbs_filter, //wb
      category_id_filter: res, //wb
      limit: paginatorRef.current.limit,
      page: paginatorRef.current.page,
      date_from, //wb
      date_to, //wb
      sort_name: sort?.[0],
      sort_order: sort?.[1],
      filters,
      ...price,
    });

    const body_ozon = JSON.stringify({
      ...working_scheme_filter,
      categoryid_filter: res,
      date_period: selectedDateOptions?.value,
      limit: paginatorRef.current.limit,
      page: paginatorRef.current.page,
      sort_name: sort?.[0],
      sort_order: sort?.[1],
      filters,
      ...price,
    });

    const current_body = mp == 'wb' ? body_wb : body_ozon;

    fetch(url, {
      body: current_body,
      method: 'POST',
      headers,
      signal: abortController.signal,
    })
      .then((res) => res.json())
      .then((json) => {
        const { data, labels, total, sort, column_size } = json;
        if (total) paginatorRef.current.setTotal(total);
        if (sort) setSort(sort);
        if (labels) setTableHeaders(labels);
        if (column_size) setColumnSize(column_size);
        setFetchedData(data?.length > 0 ? data : [[]]);
        setTableUrl(url);
        setTableBody(current_body);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setLoading(false);
        if (abortController.signal.aborted) return;
      });
  };

  const fetchTableData = (params, abortController = new AbortController()) => {
    if (pageValue != 'top' && selectedBreadcrumbsValue?.length < 1) {
      resetTable();
      return;
    }

    if (mp == 'ozon' && !selectedDateOptions?.value) return;

    setLoading(true);

    let sort;
    let filters;

    if (params) {
      [sort, filters] = params;
    }
    setLoading(true);

    let url;
    if (!window.location.hostname.match('localhost')) {
      url = `${AndreySkuHttps}/api/v1/ecomru/competitors/platform_analysis/category/${pageValue}/table/${pageValue == 'top' ? '' : 'first_level/'
        }`;
    } else {
      url = `${AndreySkuHttp}/api/v1/ecomru/competitors/platform_analysis/category/${pageValue}/table/${pageValue == 'top' ? '' : 'first_level/'
        }`;
    }

    let date_from = formateDate(date[0]).toISOString().split('T')?.[0];
    let date_to = formateDate(date[1]).toISOString().split('T')?.[0];

    let category_values = selectedBreadcrumbsValue?.map((el) => el?.value?.id);
    let res;
    if (category_values?.length > 0) {
      res = category_values.at(-1)
        ? category_values.at(-1)
        : category_values.at(-2);
    }

    const reverse =
      pageValue == 'days' || pageValue == 'working_scheme'
        ? { reverse: isReverse }
        : '';

    const body = JSON.stringify({
      fbofbs_filter: checkFbs,
      category_id_filter: res,
      limit: paginatorRef.current.limit,
      page: paginatorRef.current.page,
      date_from, //wb
      date_to, //wb
      sort_name: sort?.[0],
      sort_order: sort?.[1],
      filters,
      ...reverse,
    });

    fetch(url, {
      body,
      method: 'POST',
      headers,
      signal: abortController.signal,
    })
      .then((res) => res.json())
      .then((json) => {
        const { data, labels, total, sort, column_size } = json;
        if (total) paginatorRef.current.setTotal(total);
        if (sort) setSort(sort);
        if (labels) setTableHeaders(labels);
        if (column_size) setColumnSize(column_size);
        setFetchedData(data?.length > 0 ? data : [[]]);
        setTableUrl(url);
        setTableBody(body);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setLoading(false);
        if (abortController.signal.aborted) return;
      });
  };

  const fetchBreadCrumbs = (parentId, page, mp) => {
    let _page = page,
      limit = 25;
    const wb_id = 8;
    const ozon_id = 6;

    const params = new URL(document.location).searchParams;
    let query = params.get('mp');

    let url = `${AndreySkuHttps}/api/v1/general/categories/${!parentId ? (query === 'wb' ? wb_id : ozon_id) + '/' : ''
      }`;
    let options;

    if (!parentId) {
      _page = 1;
      options = { method: 'GET', headers };
    } else {
      const body = JSON.stringify({
        shop_id: query == 'wb' ? wb_id : ozon_id,
        parent_id: parentId,
        page: _page,
        limit,
      });
      options = { body, method: 'POST', headers };
    }

    return fetch(url, options);
  };

  const fetchBreadCrumbsSearch = (
    query,
    page = 1,
    abortController = new AbortController()
  ) => {
    let _page = page,
      limit = 25;
    let url = `${AndreySkuHttps}/api/v1/general/categories/search/`;

    const params = new URL(document.location).searchParams;
    let query_m = params.get('mp');

    const wb_id = 8;
    const ozon_id = 6;

    const body = JSON.stringify({
      limit,
      page: _page,
      query: query,
      shop_id: query_m == 'wb' ? wb_id : ozon_id,
    });

    let options = {
      body,
      method: 'POST',
      headers,
      signal: abortController.signal,
    };

    return fetch(url, options);
  };

  const fetchDate = (page = 1) => {
    let url;
    if (!window.location.hostname.match('localhost')) {
      url = `${AndreySkuHttps}/api/v1/ecomru/competitors/ozon_analysis/date_period/`;
    } else {
      url = `${AndreySkuHttp}/api/v1/ecomru/competitors/ozon_analysis/date_period/`;
    }

    const body = JSON.stringify({
      limit: 50,
      page,
    });

    fetch(url, { body, method: 'POST', headers })
      .then((res) => res.json())
      .then((json) => {
        const fromattedArr = json?.map(({ period }) => ({
          label: period,
          value: period,
        }));
        setDateOptions(fromattedArr);
        setSelectedDateOptions(fromattedArr?.[0]);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => setLoading(false));
  };

  const fetchMinMaxPrice = () => {
    let category_values = selectedBreadcrumbsValue?.map((el) => el?.value?.id);
    let res;
    if (category_values?.length > 0) {
      res = category_values.at(-1)
        ? category_values.at(-1)
        : category_values.at(-2);
    }

    if (!res) return;

    let url;
    if (!window.location.hostname.match('localhost')) {
      url = `${AndreySkuHttps}/api/v1/ecomru/competitors/${mp === 'wb' ? 'platform_analysis' : 'ozon_analysis'
        }/category/price_range/`;
    } else {
      url = `${AndreySkuHttp}/api/v1/ecomru/competitors/${mp === 'wb' ? 'platform_analysis' : 'ozon_analysis'
        }/category/price_range/`;
    }

    const params_q = new URL(document.location).searchParams;
    let query = params_q.get('mp');

    const fbofbs_filter = query == 'wb' ? { fbofbs_filter: checkFbs } : false;
    let working_scheme_filter =
      query == 'ozon'
        ? { working_scheme_filter: selectedSalesType?.value }
        : false;

    let [date_from, date_to] = selectedDateOptions?.value?.split(' - ') || [
      new Date(),
      new Date(),
    ];

    const body_wb = JSON.stringify({
      ...fbofbs_filter,
      categoryid_filter: res,
      date_from,
      date_to,
    });

    const body_ozon = JSON.stringify({
      categoryid_filter: res, // []
      date_period: selectedDateOptions?.value,
      working_scheme_filter: selectedSalesType?.value,
    });

    const current_body = mp == 'wb' ? body_wb : body_ozon;

    fetch(url, { body: current_body, method: 'POST', headers })
      .then((res) => res.json())
      .then((json) => {
        if (json) {
          let { min_price, max_price } = json;
          setMinMaxRange([min_price, max_price]);
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => setLoading(false));
  };

  const handleCheck = (data) => {
    setSelectedItems(data);
  };

  useEffect(() => {
    const abortController = new AbortController();
    if (mp === 'wb') {
      if (pageValue !== 'price_segment') {
        fetchTableData([], abortController);
      }
    } else {
      if (pageValue !== 'price_segment') {
        fetchAllAccountData([], abortController);
      }
    }
    return () => abortController.abort();
  }, []);

  useEffect(() => {
    if (pageValue == 'price_segment') {
      fetchMinMaxPrice();
    }
  }, [
    selectedSpace,
    pageValue,
    date,
    selectedSalesType,
    selectedDateOptions,
    selectedBreadcrumbsValue,
    checkFbs,
    mp,
  ]);

  useEffect(() => {
    const mp = searchParams.get('mp');
    setMp(mp);
    setPageValue(activeTab);
    resetTable();
  }, [activeTab, searchParams]);

  useEffect(() => {
    const abortController = new AbortController();
    if (mp === 'wb') {
      if (pageValue !== 'price_segment') {
        fetchTableData([], abortController);
      }
    } else {
      if (pageValue !== 'price_segment') {
        fetchAllAccountData([], abortController);
      }
    }
    fetchChartData(abortController);
    return () => abortController.abort();
  }, [
    selectedSpace,
    selectedDateOptions,
    pageValue,
    selectedSalesType,
    selectedBreadcrumbsValue,
    checkFbs,
    mp,
    date,
    choisePrice,
    isReverse,
  ]);

  useEffect(() => {
    const abortController = new AbortController();
    fetchMetricsList(abortController);
    setCheckedItems([]);
    return () => abortController.abort();
  }, [pageValue, mp, selectedSpace]);

  useEffect(() => {
    if (pageValue == 'price_segment') {
      fetchMinMaxPrice();
    }
    setSelectedBreadcrumbsValue([]);
    setSelectedDateOptions({});
    fetchDate();
  }, [selectedSpace]);

  useEffect(() => {
    const params = new URL(document.location).searchParams;
    let query = params.get('mp');
    setQuery(query);
    setMp(query);
  }, [pageValue, new URL(document.location)]);

  useEffect(() => {
    setSelectedBreadcrumbsValue([]);
    resetTable();
    resetChart();
  }, [query]);

  //графики
  useEffect(() => {
    if (pageValue == 'working_scheme') {
      return;
    } else {
      if (pageValue == 'top') {
        fetchChartData();
      }

      if (
        pageValue == 'goods' ||
        pageValue == 'category' ||
        pageValue == 'sellers' ||
        pageValue == 'brands'
      ) {
        if (selectedBreadcrumbsValue?.length) {
          fetchChartData();
        }
      }

      if (pageValue == 'days') {
        fetchChartData();
      }

      if (pageValue == 'price_segment') {
        if (choisePrice?.length > 0 && selectedBreadcrumbsValue?.length) {
          fetchChartData();
        }
      }
    }
  }, [
    selectedSpace,
    selectedItems,
    date,
    pageValue,
    checkFbs,
    tableMetric,
    choisePrice,
    selectedSalesType,
    selectedDateOptions,
  ]);

  useEffect(() => {
    setSelectedBreadcrumbsValue([]);
    setSegments(1);
    setMinMaxRange([0, 0]);
    setPageValue(btn_tab[0].value);
  }, [mp]);

  const onAction = (e) => {
    setChoisePrice([e.min_price, e.max_price]);
  };

  useEffect(() => {
    resetChart();
    resetTable();
    setTableMetric([]);
    setTableMetrics([]);
  }, [pageValue]);

  return (
    <div className="analysis-category">
      <TitlePage
        title='Анализ категорий'
      />

      <div className="toolbar-top">
        <div className="filter-group">
          <FiltersBreadCrumbs
            showMenu={showMenu}
            setShowMenu={(e) => setShowMenu(e)}
            selectedBreadcrumbsValue={selectedBreadcrumbsValue}
            setSelectedBreadcrumbsValue={setSelectedBreadcrumbsValue}
            fetchCallback={fetchBreadCrumbs}
            fetchSearch={fetchBreadCrumbsSearch}
            mapFunc={(el) => ({
              label: el.category_name,
              value: { id: el.category_id, hasChildren: el.has_children },
            })}
          // isSelectedBreadCrumsAfterButton
          // mp={query}
          />
        </div>


      </div>

      <div className="toolbar-medium">
        <Tabs tabs={btn_tab} query={`?mp=${query}`} pageValue={pageValue} />

        <div className="range-group-btn-and-range-box">
          {mp == 'wb' && (
            <Tooltip
              text={<p className='text_tooltip'>FBO <span>(продажи со склада площадки)</span> по умолчанию.
                <br /><br />
                Нажмите на переключатель чтобы увидеть FBS <span>(продажи со склада продавца)</span>
              </p>}
              maxWidth='110px'
              child={
                <CheckboxToggleBlue
                  text='FBS'
                  value={checkFbs}
                  onChange={(e) => setCheckFbs(!checkFbs)}
                />
              }
            />
          )}

          {pageValue == 'day' && (
            <div className="drop-box">
              <p className="text">По</p>
              <DropDownSelector
                options_prop={options_period}
                state={selectedPeriod}
                setState={setSelectedPeriod}
                defaultValue={selectedPeriod}
                isClearable={false}
              />
            </div>
          )}

          {mp !== 'wb' && (
            <DropDownSelector
              options_prop={dateOptions}
              state={selectedDateOptions}
              setState={setSelectedDateOptions}
              placeholder="Дата"
              fetchCallback={fetchDate}
              style={{ minWidth: '275px' }}
            />
          )}
          {mp !== 'wb' && (
            <DropDownSelector
              options_prop={sales_type}
              state={selectedSalesType}
              setState={setSelectedSalesType}
              placeholder="Тип продаж"
            />
          )}

          {mp === 'wb' && <RangeBox
date={date} setDate={(e) => setDate(e)} hideBtnGroup />}
        </div>
      </div>

      {pageValue != 'working_scheme' && (
        <DropContainer
          // name={'Продажи и остатки'}
          showDropBox={showDropBox}
          setShowDropBox={(e) => setShowDropBox(e)}
          name={chartData?.title ? chartData?.title : ''}
        >
          <LineChart
            selectedMetric={tableMetric}
            setSelectedMetric={setTableMetric}
            metricsList={tableMetrics}
            {...chartData}
          />
        </DropContainer>
      )}

      {pageValue === 'price_segment' && (
        <SliderRange
          minValue={minMaxRange[0]}
          maxValue={minMaxRange[1]}
          setState={setPriceRange}
          sliderRange={priceRange}
          setSegments={(e) => setSegments(e)}
          segments={segments}
          range={priceRange}
          minMax
          callbackHandler={() => {
            const abortController = new AbortController();
            if (mp === 'wb') {
              fetchTableData([], abortController);
            } else {
              fetchAllAccountData([], abortController);
            }
          }}
        />
      )}

      <TableBox
        loading={loading}
        fetchedData={fetchedData}
        headers={tableHeaders}
        sort={sort}
        paginator={true}
        onAction={(e) => onAction(e)}
        fetchCallback={(e) => {
          if (mp === 'wb') {
            fetchTableData(e);
          } else {
            fetchAllAccountData(e);
          }
        }}
        sortingFunc={(e) => {
          if (mp === 'wb') {
            fetchTableData(e);
          } else {
            fetchAllAccountData(e);
          }
        }}
        columnSize={columnSize}
        ref={paginatorRef}
        onEdit={(e) => e}
        onDelete={(e) => e}
        onCheck={(e) => handleCheck(e)}
        onUncheckAllDependence={[pageValue, selectedBreadcrumbsValue, mp]}
        date={date}
        isInsideTable={pageValue !== 'top' && pageValue == 'wb' ? true : false}
        tableUrl={tableUrl}
        tableBody={tableBody}
        child={(pageValue === 'days' || pageValue == 'working_scheme') && (
          <Checkbox
            value={isReverse}
            onChange={(checked) => setIsReverse(checked)}
          >Перевернуть</Checkbox>
        )} />
    </div>
  );
};

export { AnalysisCategory };
